import React from 'react'
import { Route, Routes } from "react-router-dom"
import CustomerCreateScreen from "screens/App/CRM/Customer/CustomerCreateScreen"
import CustomerDetailScreen from "screens/App/CRM/Customer/CustomerDetailScreen"
import CustomerEditScreen from "screens/App/CRM/Customer/CustomerEditScreen"
import CustomerListScreen from "screens/App/CRM/Customer/CustomerListScreen"
import NotFoundScreen from "screens/NotFoundScreen"

const CustomerRouter = () => {
  return (
    <Routes>

      <Route path="create" element={<CustomerCreateScreen />} />
      <Route path="list" element={<CustomerListScreen />} />
      <Route path=":id/detail" element={<CustomerDetailScreen />} />
      <Route path=":id/edit" element={<CustomerEditScreen />} />
      <Route path="*" element={<NotFoundScreen />} />

    </Routes>
  )
}

export default CustomerRouter;